export default "__VITE_ASSET__BOWb2Hp5__"